import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import chop_floating_point_values from '../../serviceFunctions/MonthlyAnalysis/chop_float';

export default function SharedTable({ handleOpen, setFormData, pageState, setpageState, columns, componentStyle,GridToolbar }) {
  // console.log(data)

  const handleRowClick = (e) => {
    // console.log(e.row)
    setFormData(e.row)
    handleOpen()
  }

  const getRowClassName = (params) => {
    return params.row.id%2 === 1 ? 'bg-blue-100 border-none' : ''; // Use Tailwind CSS utility classes
  };

  const cellClassName = (params) => {
    return `font-custom uppercase`;
  };

  const handlePaginationChange = (paginationMeta) => {
    setpageState((prev) => ({
      ...prev,
      page: paginationMeta.page + 1,
      pageSize: paginationMeta.pageSize,
    }));
    console.log("V : ", chop_floating_point_values(pageState.data))
  };

  const headerClassName = (params) => {
    return `bg-skin-table-header font-heading text-lg font-bold uppercase` // Use Tailwind CSS utility classes
  };
  return (
    <div 

  style={componentStyle ? componentStyle : { height: 400, width: '100%' }} 
  className="rounded-sm bg-skin-table-row w-full max-w-full sm:w-3/4 md:w-2/3 lg:w-1/2 drop-shadow-md opacity-95 overflow-x-auto"
>
  <DataGrid
    rows={chop_floating_point_values(pageState.data)}
    rowCount={pageState.total * pageState.pageSize}
    columns={columns.map((column) => ({
      ...column,
      cellClassName: cellClassName,
      headerClassName: headerClassName,
    }))}
    getRowId={(row) => row._id}
    initialState={{
      pagination: {
        paginationModel: { page: 0, pageSize: 5 },
      },
    }}
    paginationMode="server"
    onPaginationModelChange={handlePaginationChange}
    pageSizeOptions={[5, 10, 100]}
    onRowClick={setFormData ? handleRowClick : () => console.log("nothing to do")}
    getRowClassName={getRowClassName}
    disableColumnMenu={true}
    slots={{ toolbar: GridToolbar }}
    sx={{
      '& .MuiDataGrid-root': {
        border: 'none',
      },
      '& .MuiDataGrid-cell': {
        borderBottom: '1px solid #f0f0f0',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: 'var(--color-table-header)',
        borderBottom: 'none',
      },
      '& .MuiDataGrid-virtualScroller': {
        backgroundColor: 'var(--color-table-row)',
      },
      '@media (max-width: 640px)': {
        '& .MuiDataGrid-columnHeaders': {
          fontSize: '0.875rem',
        },
        '& .MuiDataGrid-cell': {
          fontSize: '0.875rem',
          padding: '8px',
        },
      },
    }}
  />
</div>
  );
}
